const autoNgTemplateLoaderTemplate1 = require('./applicationsStacksDatatable.html');

angular.module('portainer.kubernetes').component('kubernetesApplicationsStacksDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesApplicationsStacksDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    refreshCallback: '<',
    removeAction: '<',
  },
});
